import React from 'react';
import './index.scss';
import {MenuItem} from '../../../../@types/menu';
import Menu from '../../../Menu';

interface Props {
  menuItems: MenuItem[];
  isOpen: boolean;
}

const Sidebar: React.FC<Props> = ({menuItems, isOpen}) => {
  return (
    <>
      {!isOpen ? (
        <></>
      ) : (
        <>
          <div className="sidebar-size">
            <p></p>
          </div>
          <div className="sidebar-wrapper">
            <div className="sidebar-container">
              <Menu model={menuItems}/>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Sidebar;
